import PropTypes from 'prop-types';

export const HELMET_TITLE = 'FAQ';
export const CATEGORY = 'category';
export const ARTICLE = 'article';
export const ALT_ARTICLE_ICON_ARROW = 'arrow';
export const FAQ_URL = '/faq';

// Faq Actions
export const CHANGE_PAGE_ID = 'app/Faq/CHANGE_PAGE_ID';
export const RESET_STATE = 'app/Faq/RESET_STATE';

export const questionContentPropTypes = PropTypes.shape({
  content: PropTypes.string,
  imgAlt: PropTypes.string,
  imgSizePercent: PropTypes.number,
  type: PropTypes.string,
});

export const questionPropTypes = PropTypes.exact({
  name: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  updatedDate: PropTypes.string,
  meta: PropTypes.exact({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  category: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.arrayOf(questionContentPropTypes),
  relatedQuestions: PropTypes.arrayOf(PropTypes.string),
});
